<style>
  .keyWordsOutput {
    margin: auto auto;
    margin-top: 1vh;
    background-color: white;
    min-height: 50px;
    border-radius: 8px;
    padding: 10px;
    border: 1px dashed black;
  }

  .key-word--node {
    border-width: 3px;
    border-style: solid;
    border-color: #24526d;
    border-radius: 0.7rem;
    color: white;
    background-color: #203449;
    position: relative;
    display: inline-block;
    padding: 5px;
    margin: 5px;
  }
  .key-word--text:hover::after {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: auto;
    background-color: rgba(255, 255, 255, 0.5);
    /* inverse of black */
    content: '';
    background-image: url("static/icons/hand-drawn/delete.svg");
    background-position: center center;
    background-repeat: no-repeat;
    padding: 0.5rem;
    padding-top: 0.2rem;
    filter: invert(1);
    border-radius: 0.7rem;
  }

  .incorrect-spelling::before {
    position: absolute;
    bottom: 5%;
    left: 15%;
    right: 15%;
    content: "";
    border: 2px rgba(243, 58, 58, 0.514) solid;
    height: 0;
  }

  .total-key-word--wrapper {
    display: inline;
  }

  .suggested-word--container {
    position: absolute;
    padding: 0.6rem;
    border-radius: 0.4rem;
    top: 115%;
    left: 0;
    max-width: 20rem;
    background: rgba(255, 255, 255, 0.8);
    display: inline-block;
    height: fit-content;
    width: fit-content;
    overflow-wrap: break-word;
  }

  .suggested-word {
    /*TODO put back in and fix*/
    display: none;
    /* display: inline; */
    padding: 0.4rem;
    color: black;
    font-size: 0.9rem;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-weight: 200;
    background: transparent;
    border-radius: 0.4rem;
    transition: background 50ms ease-in-out; 
  }

  .suggested-word:hover {
    background: rgba(0, 0, 0, 0.25);
  }
</style>

<div class="form-group">
  <label for="keyWordsInput"
    ><span class="required--input">(*)</span>&thinsp; Write a keyword and just
    press space. Three words minimum are required. Only letters will go through.
    Click on the word to delete</label
  >
  <input
    type="text"
    class="form-control"
    id="keyWordsInput"
    placeholder="Enter Key Word Here"
    bind:value={valueInput}
    on:input={putIntoKeyWord}
  />
  <div class="keyWordsOutput">
    {#each keyWordValues as keyWordValue, i}
    <div
      class="total-key-word--wrapper"
      on:mousemove={() => {setSuggestedVis(i, true)}}
      on:blur={() => {setSuggestedVis(i, false, 400)}}
      >
      <div class="key-word--node" in:fly={{x:-20}} out:fade>
        <span
          class="{ keyWordsAdj[i].found === true ? 'correct-spelling' : 'incorrect-spelling' } key-word--text"
          on:click={() => deleteItem(i)}
        >
          <!-- TODO When Hover Trash Can should appear //use :hover::after -->
          {keyWordValue}
        </span>
        {#if keyWordsAdj[i].found === false} {#if suggestedVis[i] === true}
        <div
          class="suggested-word--container"
          transition:fade={{duration: 200}}
          on:scroll={() => setSuggestedVis(i, true)}
          on:mousemove={() => setSuggestedVis(i, true)}
          >
          {#each keyWordsAdj[i].suggestions as suggestion}
          <div class="suggested-word" on:click={() => setWord(i, suggestion.word) }>
            {suggestion.word}
          </div>
          {/each}
        </div>
        {/if} {/if}
      </div>
    </div>
    {/each}
  </div>
</div>

<script>
  import spelling from "spelling";
  import dictionary from "spelling/dictionaries/en_US.js";
  import stem from "lancaster-stemmer";
  // import { push, splice } from "svelte-extras";
  import { fly, fade } from "svelte-transitions";

  const dict = new spelling(dictionary); //TODO possibley put into global scope
  // //{ found: true, word: 'yes', rank: 5398 }

  let valueInput = null,
    keyWordValues = [],
    keyWordsAdj = [],
    suggestedVis = []
  export let keyWords
  function setWord(i, newWord) {
    keyWordValues[i] = newWord;
    keyWordsAdj[i] = dict.lookup(newWord);
    getWords()
  }
  function putIntoKeyWord() {
    const lastChar = valueInput.substring(valueInput.length - 1);
    if (lastChar === " " || lastChar === "," || lastChar === ".") {
      const text = valueInput.replace(/ ,./g, "").toLowerCase();
      keyWordsAdj = [...keyWordsAdj, dict.lookup(text)]
      keyWordValues = [...keyWordValues, text]
      valueInput = null
    }
    getWords()
  }
  function deleteItem(toDelteI) {
    // keyWordValues.splice(i, 1);
    // keyWordsAdj.splice(i, 1)
    keyWordValues = keyWordValues.filter((item, i) => i !== toDelteI)
    keyWordsAdj = keyWordsAdj.filter((item, i) => i !== toDelteI)
    getWords()
  }
  function getWords() {
    let keyWordStems = [];
    for (let i = 0; i < keyWordValues.length; i++) {
      keyWordStems.push(stem(keyWordValues[i].replace(",", "").trim()));
    }
    keyWords = keyWordStems.join(", ");
  }
  function setSuggestedVisAll(state) {
    suggestedVis = suggestedVis.map((item) => {
      state;
    });
  }
  function setSuggestedVis(i, state, timeout=0) {
    setSuggestedVisAll(false);
    const func = () => {
      suggestedVis[i] = state;
    };
    setTimeout(func, timeout);
  }
</script>